/** Paleta suave (verde pastel + acento cálido) para landings tipo En Producción con MEM. */
export const light = {
  alternate: {
    main: '#f4fbf7',
    dark: '#eaf6f0',
  },
  cardShadow: 'rgba(94, 154, 132, 0.12)',
  mode: 'light',
  primary: {
    main: '#7eb89e',
    light: '#b5dcc8',
    dark: '#5a9a7e',
    contrastText: '#fff',
  },
  secondary: {
    light: '#f5edd8',
    main: '#c4a76d',
    dark: '#a68f58',
    contrastText: '#fff',
  },
  text: {
    primary: '#2a3830',
    secondary: '#5a6860',
  },
  divider: 'rgba(90, 154, 126, 0.18)',
  background: {
    paper: '#fff',
    default: '#fafdf9',
    level2: '#f3faf6',
    level1: '#fff',
  },
};

export const dark = {
  alternate: {
    main: '#1a2420',
    dark: '#141c19',
  },
  cardShadow: 'rgba(0, 0, 0, 0.1)',
  common: {
    black: '#000',
    white: '#fff',
  },
  mode: 'dark',
  primary: {
    main: '#9dccb8',
    light: '#c0e4d4',
    dark: '#7aad96',
    contrastText: '#142018',
  },
  secondary: {
    light: '#f5ead0',
    main: '#e6d5ae',
    dark: '#d4c08f',
    contrastText: 'rgba(28, 24, 18, 0.92)',
  },
  text: {
    primary: '#eef5f1',
    secondary: '#b8c4bc',
  },
  divider: 'rgba(255, 255, 255, 0.12)',
  background: {
    paper: '#1f2a25',
    default: '#1a2420',
    level2: '#243028',
    level1: '#1e2822',
  },
};
